document.addEventListener('DOMContentLoaded', function() {
  // Swatch/variant/slider UI logic (no cart logic)

  // Swatch selection and variant picker logic
  document.querySelectorAll('.siblings__swatches').forEach(function(container) {
    var parentForm = container.closest('form');
    var swatches = container.querySelectorAll('.siblings__swatch');
    var selected = false;

    if (parentForm) {
      // Highlight the default swatch based on the select with name="id" or fallback to the first select
      var defaultSelect = parentForm.querySelector('.sibling-size-select[name="id"]') ||
                          parentForm.querySelector('.sibling-size-select');
      if (defaultSelect) {
        var defaultSiblingId = defaultSelect.getAttribute('data-sibling-id');
        var defaultSwatch = container.querySelector('.siblings__swatch[data-sibling-id="' + defaultSiblingId + '"]');
        if (defaultSwatch) {
          defaultSwatch.classList.add('siblings__swatch--selected');
          selected = true;
        }
        var variantInput = parentForm.querySelector('[name="id"]');
        if (variantInput && defaultSelect.value) {
          variantInput.value = defaultSelect.value;
        }
      }
    }
    // If nothing was selected, select the first swatch (covers single sibling/variant case)
    if (!selected && swatches.length > 0) {
      swatches[0].classList.add('siblings__swatch--selected');
    }

    // Swatch click handler
    container.addEventListener('click', function(e) {
      var swatch = e.target.closest('.siblings__swatch');
      if (!swatch) return;
      container.querySelectorAll('.siblings__swatch').forEach(function(btn) {
        btn.classList.remove('siblings__swatch--selected');
      });
      swatch.classList.add('siblings__swatch--selected');
      var parentForm = swatch.closest('form');
      // Hide all selects, show only the selected sibling's select
      parentForm.querySelectorAll('.sibling-size-select').forEach(function(sel) {
        sel.style.display = 'none';
      });
      var selectToShow = parentForm.querySelector('#variant-' + swatch.getAttribute('data-sibling-id'));
      if (selectToShow) {
        selectToShow.style.display = '';
        // Hide select if only one variant
        if (selectToShow.options.length === 1) {
          selectToShow.style.display = 'none';
        }
        selectToShow.selectedIndex = 0;
        parentForm.querySelectorAll('.sibling-size-select').forEach(function(sel) {
          sel.removeAttribute('name');
        });
        selectToShow.setAttribute('name', 'id');
        var variantInput = parentForm.querySelector('[name="id"]');
        if (variantInput) {
          variantInput.value = selectToShow.value;
        }
        selectToShow.dispatchEvent(new Event('change'));
      }
      // Update main image for the selected sibling
      var upsellItem = parentForm.closest('.upsell-slider__item');
      var mainImg = upsellItem ? upsellItem.querySelector('.img-fluid[id^="upsell-main-img-"]') : null;
      var swatchImg = swatch.querySelector('img');
      if (swatchImg && mainImg) {
        mainImg.src = swatch.dataset.mainImg;
        mainImg.alt = swatchImg ? swatchImg.alt : '';
      }
    });

    // Size select change handler
    if (parentForm) {
      parentForm.querySelectorAll('.sibling-size-select').forEach(function(select) {
        select.addEventListener('change', function() {
          var variantInput = parentForm.querySelector('[name="id"]');
          if (variantInput) {
            variantInput.value = select.value;
          }
        });
      });
    }
  });

  // Variant selection: update price UI
  document.querySelectorAll('select[id^="variant-"]').forEach(function(select) {
    select.addEventListener('change', function() {
      var productId = this.id.replace('variant-', '');
      var selectedOption = this.options[this.selectedIndex];
      var priceMatch = selectedOption.text.match(/- (.+)$/);
      if (priceMatch) {
        var priceSpan = document.getElementById('price-' + productId);
        if (priceSpan) priceSpan.textContent = priceMatch[1];
      }
      var compareAt = selectedOption.getAttribute('data-compare-at');
      var compareAtSpan = document.getElementById('compare-at-' + productId);
      if (compareAt && compareAt !== '' && (!priceMatch || compareAt !== priceMatch[1])) {
        compareAtSpan.textContent = compareAt;
        compareAtSpan.style.textDecoration = 'line-through';
        compareAtSpan.style.color = '#888';
      } else if (compareAtSpan) {
        compareAtSpan.textContent = '';
      }
    });
  });

  // Upsell slider logic (arrows, navigation)
  var slider = document.querySelector('.upsell-slider');
  if (slider) {
    var items = slider.querySelectorAll('.upsell-slider__item');
    var left = slider.querySelector('.upsell-slider__arrow--left');
    var right = slider.querySelector('.upsell-slider__arrow--right');
    var current = 0;

    function updateSlider() {
      items.forEach(function(item, idx) {
        item.style.display = idx === current ? 'block' : 'none';
      });
      if (left) left.disabled = current === 0;
      if (right) right.disabled = current === items.length - 1;
    }
    
    if (left) {
      left.addEventListener('click', function() {
        if (current > 0) {
          current--;
          updateSlider();
        }
      });
    }
    if (right) {
      right.addEventListener('click', function() {
        if (current < items.length - 1) {
          current++;
          updateSlider();
        }
      });
    }

    updateSlider();
  }
});